import {AbstractControl} from '@angular/forms';

export function defaultValueValidator(value: any, key: string = null) {

    // Marca invalido cuando el control tiene el valor indicado, pj: "**"
    // Si el control devuelve un objeto se puede especificar la la propiedad mediante el parametro key
    return (control: AbstractControl): { [key: string]: boolean } | null => {
        if ((key && control.value && control.value[key] === value) || control.value == value) {
            return { 'defaultInvalid': true };
        }
        return null;
    }
}
